<template>
    <div class="login-page">
        <div class="login-main">
            <div class="login-form">
                <div class="center-box">
                    <div style="text-align: left; top: -50px; position: absolute;">
                        <img src="./images/logo-text.png" alt="netease"></div>
                    <el-row>
                        <el-col :span="12">
                            <div class="login-left"></div>
                        </el-col>
                        <el-col :span="12" class="rule-form">
                            <transition :name="transition">
                                <div class="transition-wrap" :key="transitionKey">
                                    <component :is="currentView" @change="trans" :projects="options"
                                               @success="successLogin"></component>
                                </div>
                            </transition>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <div class="footer">
            <img src="./images/login-logo.png" alt="logo">
            <p class="mt-10">{{ copyrightText }}</p>
            <p class="ml-10" style="text-decoration:underline">
                <a :href="icpLink" target="_blank" style="color:#333">{{icpText}}</a>
            </p>
        </div>
    </div>
</template>
<script type="text/javascript">
    import Main from './main'
    import Project from './project'
    import switchProjectMixin from './switchProjectMixin'
    import openIDhandlerMixin from './openIDhandlerMixin'

    export default {
        mixins: [switchProjectMixin, openIDhandlerMixin],
        data () {
            return {
                transition: 'slide-right',
                transitionKey: 1,
                currentView: Main,
                options: [],
                copyrightText: '网易公司版权所有©1997-2020',
                icpLink: 'http://www.beian.miit.gov.cn',
                icpText: 'ICP备案：粤B2-20090191-18'
            }
        },
        created () {
            window.frontendCommonContext.onLoad(() => {
                if (window.frontendCommonConfig) {
                    this.icpLink = window.frontendCommonConfig.icpLink
                    this.icpText = window.frontendCommonConfig.icpText['.163.com']
                    this.copyrightText = window.frontendCommonConfig.copyright
                }
            })
        },
        computed: {
            year () {
                return new Date().getFullYear()
            }
        },
        methods: {
            trans (options = []) {
                this.options = options
                this.currentView = this.currentView === Main ? Project : Main
                this.transition = this.transition === 'slide-left' ? 'slide-right' : 'slide-left'
                this.transitionKey = this.transitionKey === 1 ? 2 : 1
            }
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~variable";

    @-moz-keyframes background-move {
        0% {
            background-position-x : 0
        }
        to {
            background-position-x : -1920px
        }
    }

    @-webkit-keyframes background-move {
        0% {
            background-position-x : 0
        }
        to {
            background-position-x : -1920px
        }
    }

    @keyframes background-move {
        0% {
            background-position-x : 0
        }
        to {
            background-position-x : -1920px
        }
    }

    .login-page {
        height                : 100%;
        background            : #edf1f2 url('./images/bg.png') no-repeat bottom;
        background-size       : 200%;
        -moz-animation        : background-move 30s linear infinite;
        -webkit-animation     : background-move 30s linear infinite;
        animation             : background-move 30s linear infinite;
        background-position-y : bottom;
        background-position-x : 0;

        .login-main {
            display      : table;
            table-layout : fixed;
            height       : 100%;
            width        : 100%;

            .login-form {
                display        : table-cell;
                vertical-align : middle;
                text-align     : center;
                width          : 100%;
                height         : 100%;
            }

            $login-height : 550px;

            .center-box {
                width         : 1000px;
                height        : $login-height;
                margin        : 0 auto;
                position      : relative;
                box-sizing    : border-box;
                box-shadow    : 0 0 6px rgba(0, 0, 0, 0.2);
                background    : #fff;
                border-radius : $border-radius;
            }

            .login-left {
                height     : $login-height;
                background : url('./images/left-side.png') no-repeat center;
            }

            .rule-form {
                display    : inline-block;
                box-sizing : border-box;
                .transition-wrap {
                    position    : absolute;
                    top         : 60px;
                    padding     : 30px 60px 20px;
                    box-sizing  : border-box;
                    border-left : 1px solid #f2f5f9;
                    height      : 415px;
                    width       : 440px;
                    transition  : all .5s cubic-bezier(.55, 0, .1, 1);
                }
                .line {
                    margin     : 25px 0 0;
                    border-top : 1px solid $border-color;
                    span {
                        display    : inline-block;
                        padding    : 0 10px;
                        background : #fff;
                        position   : relative;
                        top        : -12px;
                    }
                }
                .title {
                    font-size     : 18px;
                    color         : #999;
                    margin-top    : 20px;
                    margin-bottom : 40px;
                    .divider {
                        margin         : 0 30px;
                        height         : 17px;
                        display        : inline-block;
                        border-left    : 1px solid #e0e0e0;
                        vertical-align : middle;
                    }
                    .sub-title {
                        cursor : pointer;
                        &.active {
                            font-weight : bold;
                            color       : $theme-color;
                        }
                    }
                }
                .select-drop {
                    .el-select {
                        display : block;
                    }
                }
            }
        }

        .footer {
            text-align : center;
            margin-top : -$main-footer-height * 2;
            height     : auto;
        }
    }
</style>


// WEBPACK FOOTER //
// login.vue?f3444a16